module.exports = __webpack_public_path__ + "static/media/linkedin-logo.ce66327a.svg";